import { css, cx } from 'emotion';
import React from 'react';
import { useUrgencyCategories } from './provider';
import { UrgencyCategoryType } from './types';

export const UrgencyCategories: React.FC = () => {
    const categories = useUrgencyCategories();

    return (
        <>
            {categories[UrgencyCategoryType.EarlyBird] && (
                <div
                    className={cx(
                        styles.base,
                        styles[UrgencyCategoryType.EarlyBird],
                    )}
                >
                    Early access
                </div>
            )}
            {categories[UrgencyCategoryType.Popular] && (
                <div
                    className={cx(
                        styles.base,
                        styles[UrgencyCategoryType.Popular],
                    )}
                >
                    Popular
                </div>
            )}
            {categories[UrgencyCategoryType.New] && (
                <div
                    className={cx(styles.base, styles[UrgencyCategoryType.New])}
                >
                    Just added!
                </div>
            )}
        </>
    );
};

const styles = {
    base: css`
        border-radius: 8px;
        column-gap: 8px;
        color: #1e0a3c;
        display: inline-flex;
        flex-shrink: 0;
        font-weight: 600;
        line-height: 1;
        margin: 4px;
        padding: 7px 12px;
    `,
    [UrgencyCategoryType.EarlyBird]: css`
        background-color: #ffe6be;
    `,
    [UrgencyCategoryType.Popular]: css`
        background-color: #faafa0;
    `,
    [UrgencyCategoryType.New]: css`
        background-color: #cddfd6;
    `,
};
